import React, { useState } from "react";
import Footer from "../../../components/Footer/Footer";
import Navbar from "../../../components/Navbar/Navbar";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import styles from "./AdminHome.module.css"; // Assuming CSS module for styling
import { Button } from "@mui/material";

function AdminHome() {
  const [searchParams] = useSearchParams();
  const secret = searchParams.get("secret");

  const [isAdmin, setIsAdmin] = useState(false);
  const [licenseApprovals, setLicenseApprovals] = useState([]);

  const validateAdmin = async () => {
    try {
      const requestData = {
        secret: secret,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/admin/auth`,
        requestData,
        {
          headers: {},
        }
      );

      if (response.status === 200 && response.data.success) {
        setIsAdmin(true);
        fetchLicenseApprovals();
      } else {
        setIsAdmin(false);
        toast.error("Invalid access!");
      }
    } catch (error) {
      console.error("Error: ", error);
      toast.error("Error while authorising. Please try again!");
    }
  };

  const fetchLicenseApprovals = async () => {
    try {
      const requestData = {
        secret: secret,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/admin/pro-licenses/list`,
        requestData,
        {
          headers: {},
        }
      );

      if (response.status === 200 && response.data.success) {
        setLicenseApprovals(response.data.data); // Store license list in state
      } else {
        // console.log("Some error occurred!");
        toast.error("Error while fetching license approvals!");
      }
    } catch (error) {
      console.error("Error: ", error);
      toast.error("Error while fetching license approvals!");
    }
  };

  const handleLicenseAction = async (
    professionalId,
    actionType,
    licenseType
  ) => {
    if (actionType == "reject") {
      ("coming soon!");
      return;
    }

    try {
      const requestData = {
        secret: secret,
        professionalId,
        action: actionType, // 'accept' or 'reject'
        licenseType: licenseType, // 'broker' or 'realtor'
      };

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/admin/pro-licenses/action`,
        requestData,
        {
          headers: {},
        }
      );

      if (response.status === 200 && response.data.success) {
        toast.success(
          `${
            licenseType.charAt(0).toUpperCase() + licenseType.slice(1)
          } license ${actionType}ed successfully!`
        );
        fetchLicenseApprovals(); // Refresh the list after action
      } else {
        toast.error("Action failed!");
      }
    } catch (error) {
      console.error("Error: ", error);
      toast.error(`Error performing ${licenseType} license action!`);
    }
  };

  useEffect(() => {
    if (secret) {
      validateAdmin();
    }
  }, [secret]);

  return (
    <div>
      <Navbar />
      <div className={styles.adminHomeContainer}>
        <h1>Admin Home</h1>
        <div>
          {isAdmin ? (
            <div>
              <h2>Pending License Verifications</h2>
              <div className={styles.licenseList}>
                {licenseApprovals.length > 0 ? (
                  licenseApprovals.map((license) => (
                    <div
                      key={license.professional_id}
                      className={styles.licenseCard}
                    >
                      <h3>
                        {license.first_name} {license.last_name}
                      </h3>
                      <p>Email: {license.email}</p>

                      {/* Broker License */}
                      {license.broker_license_number &&
                        !license.broker_license_verified_at && (
                          <div>
                            <p>
                              Broker License: {license.broker_license_number}
                            </p>
                            <div className={styles.actions}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  handleLicenseAction(
                                    license.professional_id,
                                    "accept",
                                    "broker"
                                  )
                                }
                              >
                                Accept Broker License
                              </Button>
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={() =>
                                  handleLicenseAction(
                                    license.professional_id,
                                    "reject",
                                    "broker"
                                  )
                                }
                              >
                                Reject Broker License
                              </Button>
                            </div>
                          </div>
                        )}

                      {/* Realtor License */}
                      {license.realtor_license_number &&
                        !license.realtor_license_verified_at && (
                          <div>
                            <p>
                              Realtor License: {license.realtor_license_number}
                            </p>
                            <div className={styles.actions}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  handleLicenseAction(
                                    license.professional_id,
                                    "accept",
                                    "realtor"
                                  )
                                }
                              >
                                Accept Realtor License
                              </Button>
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={() =>
                                  handleLicenseAction(
                                    license.professional_id,
                                    "reject",
                                    "realtor"
                                  )
                                }
                              >
                                Reject Realtor License
                              </Button>
                            </div>
                          </div>
                        )}
                    </div>
                  ))
                ) : (
                  <p>No pending license verifications.</p>
                )}
              </div>
            </div>
          ) : (
            <div>Unauthorized Access</div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AdminHome;
